// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { benefitPlansCreateBenefitPlanGroup, benefitPlansDeleteBenefitPlanGroup, benefitPlansGetBenefitPlanGroup, benefitPlansGetBenefitPlanGroupPremiums, benefitPlansListBenefitPlanGroups, benefitPlansReorderBenefitPlanGroups, benefitPlansUpdateBenefitPlan, benefitPlansUpdateBenefitPlanGroup, benefitPlansUpsertBenefitPlan, type Options, proposalsAddProposalPlanToGroup, proposalsCreateProposalForRfp, proposalsDeleteProposalCommission, proposalsDeleteProposalPlan, proposalsDeleteProposalPlanGroup, proposalsDisregardProposalPlanGroup, proposalsGetProposal, proposalsListProposalsForRfp, proposalsPromoteProposalPlanGroup, proposalsReplaceProposalPlanGroup, proposalsRestoreProposalPlan, proposalsRestoreProposalPlanGroup, proposalsUpdateProposalCommission, proposalsUpdateProposalPlanBenefits, proposalsUpdateProposalPlanFields, proposalsUpdateProposalPlanGroupFields, rfpsExportRfpPayload, rfpsGetRfp, rfpsListCarrierNoteExistence, rfpsSetCoverageCompletion, rfpsUpsertFieldComments } from '../sdk.gen';
import type { BenefitPlansCreateBenefitPlanGroupData, BenefitPlansCreateBenefitPlanGroupResponse, BenefitPlansDeleteBenefitPlanGroupData, BenefitPlansDeleteBenefitPlanGroupResponse, BenefitPlansGetBenefitPlanGroupData, BenefitPlansGetBenefitPlanGroupPremiumsData, BenefitPlansGetBenefitPlanGroupPremiumsResponse, BenefitPlansGetBenefitPlanGroupResponse, BenefitPlansListBenefitPlanGroupsData, BenefitPlansListBenefitPlanGroupsResponse, BenefitPlansReorderBenefitPlanGroupsData, BenefitPlansReorderBenefitPlanGroupsResponse, BenefitPlansUpdateBenefitPlanData, BenefitPlansUpdateBenefitPlanGroupData, BenefitPlansUpdateBenefitPlanGroupResponse, BenefitPlansUpdateBenefitPlanResponse, BenefitPlansUpsertBenefitPlanData, BenefitPlansUpsertBenefitPlanResponse, ProposalsAddProposalPlanToGroupData, ProposalsAddProposalPlanToGroupResponse, ProposalsCreateProposalForRfpData, ProposalsCreateProposalForRfpResponse, ProposalsDeleteProposalCommissionData, ProposalsDeleteProposalCommissionResponse, ProposalsDeleteProposalPlanData, ProposalsDeleteProposalPlanGroupData, ProposalsDeleteProposalPlanGroupResponse, ProposalsDeleteProposalPlanResponse, ProposalsDisregardProposalPlanGroupData, ProposalsDisregardProposalPlanGroupResponse, ProposalsGetProposalData, ProposalsGetProposalResponse, ProposalsListProposalsForRfpData, ProposalsListProposalsForRfpResponse, ProposalsPromoteProposalPlanGroupData, ProposalsPromoteProposalPlanGroupResponse, ProposalsReplaceProposalPlanGroupData, ProposalsReplaceProposalPlanGroupResponse, ProposalsRestoreProposalPlanData, ProposalsRestoreProposalPlanGroupData, ProposalsRestoreProposalPlanGroupResponse, ProposalsRestoreProposalPlanResponse, ProposalsUpdateProposalCommissionData, ProposalsUpdateProposalCommissionResponse, ProposalsUpdateProposalPlanBenefitsData, ProposalsUpdateProposalPlanBenefitsResponse, ProposalsUpdateProposalPlanFieldsData, ProposalsUpdateProposalPlanFieldsResponse, ProposalsUpdateProposalPlanGroupFieldsData, ProposalsUpdateProposalPlanGroupFieldsResponse, RfpsExportRfpPayloadData, RfpsExportRfpPayloadResponse, RfpsGetRfpData, RfpsGetRfpResponse, RfpsListCarrierNoteExistenceData, RfpsListCarrierNoteExistenceResponse, RfpsSetCoverageCompletionData, RfpsSetCoverageCompletionError, RfpsSetCoverageCompletionResponse, RfpsUpsertFieldCommentsData, RfpsUpsertFieldCommentsResponse2 } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const benefitPlansListBenefitPlanGroupsQueryKey = (options: Options<BenefitPlansListBenefitPlanGroupsData>) => createQueryKey('benefitPlansListBenefitPlanGroups', options, false, [
    'btx',
    'rfps',
    'benefit-plan-groups'
]);

/**
 * List benefit plan groups
 *
 * Returns all benefit plan groups for the given RFP and coverage type,
 * ordered by position. Optionally filter by product type.
 *
 */
export const benefitPlansListBenefitPlanGroupsOptions = (options: Options<BenefitPlansListBenefitPlanGroupsData>) => queryOptions<BenefitPlansListBenefitPlanGroupsResponse, AxiosError<DefaultError>, BenefitPlansListBenefitPlanGroupsResponse, ReturnType<typeof benefitPlansListBenefitPlanGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await benefitPlansListBenefitPlanGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: benefitPlansListBenefitPlanGroupsQueryKey(options)
});

/**
 * Create a benefit plan group
 *
 * Creates a new benefit plan group in one of two modes:
 *
 * **From scratch** — provide `rfpId` + `coverageType` and a
 * `benefitPlanGroup` object with the desired product type, policy
 * period, and size. Empty plan shells are generated automatically.
 *
 * **Clone from existing** — provide `referenceGroupId` to copy all
 * plan data (carrier names, rates, funding types, benefits) from an
 * existing group. Product type and size are inherited; policy period
 * and nickname can be overridden.
 *
 * Only one mode may be specified per request.
 *
 */
export const benefitPlansCreateBenefitPlanGroupMutation = (options?: Partial<Options<BenefitPlansCreateBenefitPlanGroupData>>): UseMutationOptions<BenefitPlansCreateBenefitPlanGroupResponse, AxiosError<DefaultError>, Options<BenefitPlansCreateBenefitPlanGroupData>> => {
    const mutationOptions: UseMutationOptions<BenefitPlansCreateBenefitPlanGroupResponse, AxiosError<DefaultError>, Options<BenefitPlansCreateBenefitPlanGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await benefitPlansCreateBenefitPlanGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a benefit plan group
 *
 * Deletes a benefit plan group and its plans. At least one group with the
 * required primary policy period must remain after deletion.
 *
 */
export const benefitPlansDeleteBenefitPlanGroupMutation = (options?: Partial<Options<BenefitPlansDeleteBenefitPlanGroupData>>): UseMutationOptions<BenefitPlansDeleteBenefitPlanGroupResponse, AxiosError<DefaultError>, Options<BenefitPlansDeleteBenefitPlanGroupData>> => {
    const mutationOptions: UseMutationOptions<BenefitPlansDeleteBenefitPlanGroupResponse, AxiosError<DefaultError>, Options<BenefitPlansDeleteBenefitPlanGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await benefitPlansDeleteBenefitPlanGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const benefitPlansGetBenefitPlanGroupQueryKey = (options: Options<BenefitPlansGetBenefitPlanGroupData>) => createQueryKey('benefitPlansGetBenefitPlanGroup', options, false, [
    'btx',
    'rfps',
    'benefit-plan-groups'
]);

/**
 * Get a benefit plan group
 *
 * Returns a single benefit plan group with all nested benefit plans.
 */
export const benefitPlansGetBenefitPlanGroupOptions = (options: Options<BenefitPlansGetBenefitPlanGroupData>) => queryOptions<BenefitPlansGetBenefitPlanGroupResponse, AxiosError<DefaultError>, BenefitPlansGetBenefitPlanGroupResponse, ReturnType<typeof benefitPlansGetBenefitPlanGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await benefitPlansGetBenefitPlanGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: benefitPlansGetBenefitPlanGroupQueryKey(options)
});

/**
 * Update a benefit plan group
 *
 * Updates mutable properties of a group. Changing `size` triggers a
 * resize — plans are added or removed to match the new option count.
 * Send `expectedSize` with it to make the resize conditional on the
 * size you read; a stale value is refused with 409.
 *
 */
export const benefitPlansUpdateBenefitPlanGroupMutation = (options?: Partial<Options<BenefitPlansUpdateBenefitPlanGroupData>>): UseMutationOptions<BenefitPlansUpdateBenefitPlanGroupResponse, AxiosError<DefaultError>, Options<BenefitPlansUpdateBenefitPlanGroupData>> => {
    const mutationOptions: UseMutationOptions<BenefitPlansUpdateBenefitPlanGroupResponse, AxiosError<DefaultError>, Options<BenefitPlansUpdateBenefitPlanGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await benefitPlansUpdateBenefitPlanGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const benefitPlansGetBenefitPlanGroupPremiumsQueryKey = (options: Options<BenefitPlansGetBenefitPlanGroupPremiumsData>) => createQueryKey('benefitPlansGetBenefitPlanGroupPremiums', options, false, [
    'btx',
    'rfps',
    'benefit-plan-groups'
]);

/**
 * Get a benefit plan group's premiums
 *
 * Returns only the on-demand premium rollups for a group (group totals
 * plus per-plan premiums). Lets the rates summary refresh premiums after
 * an inline rate edit without refetching the full group payload, which
 * would remount the editable rates grid. Premiums are computed from the
 * rates and never persisted.
 *
 */
export const benefitPlansGetBenefitPlanGroupPremiumsOptions = (options: Options<BenefitPlansGetBenefitPlanGroupPremiumsData>) => queryOptions<BenefitPlansGetBenefitPlanGroupPremiumsResponse, AxiosError<DefaultError>, BenefitPlansGetBenefitPlanGroupPremiumsResponse, ReturnType<typeof benefitPlansGetBenefitPlanGroupPremiumsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await benefitPlansGetBenefitPlanGroupPremiums({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: benefitPlansGetBenefitPlanGroupPremiumsQueryKey(options)
});

/**
 * Reorder benefit plan groups
 *
 * Sets the display order of groups for a given RFP, coverage type, and
 * product type. All group IDs for that combination must be included.
 *
 */
export const benefitPlansReorderBenefitPlanGroupsMutation = (options?: Partial<Options<BenefitPlansReorderBenefitPlanGroupsData>>): UseMutationOptions<BenefitPlansReorderBenefitPlanGroupsResponse, AxiosError<DefaultError>, Options<BenefitPlansReorderBenefitPlanGroupsData>> => {
    const mutationOptions: UseMutationOptions<BenefitPlansReorderBenefitPlanGroupsResponse, AxiosError<DefaultError>, Options<BenefitPlansReorderBenefitPlanGroupsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await benefitPlansReorderBenefitPlanGroups({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert a benefit plan
 *
 * Creates or updates a single benefit plan on an RFP using a
 * composite key match.
 *
 * **Matching:** The plan is matched to an existing record using:
 * - `coverageType` (dental, std, vision, …)
 * - `type` (ppo, notApplicable, …)
 * - `policyPeriod` (current, …)
 * - `optionName` (high, low, notApplicable)
 *
 * If a match is found, the plan is updated (only provided fields
 * are changed). If no match is found, a new coverage, group, and
 * plan are created.
 *
 * The operation is idempotent — sending the same payload twice
 * produces the same result.
 *
 */
export const benefitPlansUpsertBenefitPlanMutation = (options?: Partial<Options<BenefitPlansUpsertBenefitPlanData>>): UseMutationOptions<BenefitPlansUpsertBenefitPlanResponse, AxiosError<DefaultError>, Options<BenefitPlansUpsertBenefitPlanData>> => {
    const mutationOptions: UseMutationOptions<BenefitPlansUpsertBenefitPlanResponse, AxiosError<DefaultError>, Options<BenefitPlansUpsertBenefitPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await benefitPlansUpsertBenefitPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a benefit plan
 *
 * Partially updates a single benefit plan. Only provided fields are
 * changed. The plan `type` is immutable after initial creation.
 *
 * The `benefits` field is polymorphic — its shape depends on the
 * coverage type (dental, vision, medical, etc.).
 *
 * Setting `eligibilityClasses` to an empty array clears all class
 * assignments; omitting the field leaves them unchanged.
 *
 * A field of `benefits` sent as null is left as it is. To empty one,
 * name it in `clearBenefitFields`, with `benefits` (whose `objectType`
 * says which benefit); a name that is not a nullable field of that
 * benefit is a 400 naming it, and nothing is saved.
 *
 */
export const benefitPlansUpdateBenefitPlanMutation = (options?: Partial<Options<BenefitPlansUpdateBenefitPlanData>>): UseMutationOptions<BenefitPlansUpdateBenefitPlanResponse, AxiosError<DefaultError>, Options<BenefitPlansUpdateBenefitPlanData>> => {
    const mutationOptions: UseMutationOptions<BenefitPlansUpdateBenefitPlanResponse, AxiosError<DefaultError>, Options<BenefitPlansUpdateBenefitPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await benefitPlansUpdateBenefitPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const proposalsListProposalsForRfpQueryKey = (options: Options<ProposalsListProposalsForRfpData>) => createQueryKey('proposalsListProposalsForRfp', options, false, ['Proposals']);

/**
 * List proposals for an RFP
 *
 * Returns the deliverable proposals for a given RFP by default — the
 * active version of each carrier lane (`is_active_version = true`), i.e.
 * what reaches the marketing presentation.
 *
 * Pass `scope` to select a different read scope (ADR-031):
 * - `scope=board` — active versions plus un-actioned pending requotes (the
 * SBS board, including the pending requote column).
 * - `scope=all` — every version: active, pending, and actioned historical
 * (the SBS Quote History full-history view).
 *
 * Returns an empty array `[]` (not an error) when no proposals
 * exist for the RFP.
 *
 * Without `include=coverages`, returns summary-level data only.
 * With `include=coverages`, returns full detail including coverages,
 * plan groups, plans, and rate schedules, with the enrollment flags and
 * the Current plan's figures that compare each carrier quote with the
 * Current plan. If the Current plan cannot be read, the quotes are returned
 * without the flags.
 *
 */
export const proposalsListProposalsForRfpOptions = (options: Options<ProposalsListProposalsForRfpData>) => queryOptions<ProposalsListProposalsForRfpResponse, AxiosError<DefaultError>, ProposalsListProposalsForRfpResponse, ReturnType<typeof proposalsListProposalsForRfpQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await proposalsListProposalsForRfp({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: proposalsListProposalsForRfpQueryKey(options)
});

/**
 * Create an analyst proposal (materialize a placeholder)
 *
 * Creates an analyst-authored proposal (`origin = analyst`) for a carrier
 * under an RFP. Only `origin = analyst` is accepted — carrier proposals are
 * created by ingestion, never via this endpoint.
 *
 * When a `materialize` block is supplied, the endpoint atomically turns a
 * synthesized "awaiting quote" placeholder column into a real proposal plan
 * group: it find-or-creates the active analyst proposal for the carrier, adds
 * the plan group shaped from the referenced RFP benefit plan group, and
 * applies the single edited benefit — all in one transaction (ADR-024). The
 * carrier's synthesized placeholder for that coverage is then suppressed on
 * read in favor of this real analyst column.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsCreateProposalForRfpMutation = (options?: Partial<Options<ProposalsCreateProposalForRfpData>>): UseMutationOptions<ProposalsCreateProposalForRfpResponse, AxiosError<DefaultError>, Options<ProposalsCreateProposalForRfpData>> => {
    const mutationOptions: UseMutationOptions<ProposalsCreateProposalForRfpResponse, AxiosError<DefaultError>, Options<ProposalsCreateProposalForRfpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsCreateProposalForRfp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const proposalsGetProposalQueryKey = (options: Options<ProposalsGetProposalData>) => createQueryKey('proposalsGetProposal', options, false, ['Proposals']);

/**
 * Get a proposal
 *
 * Returns a single proposal with the full nested entity tree
 * eagerly loaded: proposal → coverages → plan groups → plans
 * (with benefits).
 *
 * Plan `identifier` values (e.g., `DEN-1-1`, `VIS-2-3`) are
 * computed at response time and not stored. Benefits are returned
 * in the canonical v5 shape with internal persistence fields
 * (`id`, `createdAt`, `updatedAt`) stripped from domain wrappers.
 *
 * For dental benefits, `serviceWaitingPeriods` is always included
 * in the response (never omitted), even when the array is empty.
 *
 */
export const proposalsGetProposalOptions = (options: Options<ProposalsGetProposalData>) => queryOptions<ProposalsGetProposalResponse, AxiosError<DefaultError>, ProposalsGetProposalResponse, ReturnType<typeof proposalsGetProposalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await proposalsGetProposal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: proposalsGetProposalQueryKey(options)
});

/**
 * Update proposal plan benefits
 *
 * Replaces the benefit data for a single carrier proposal plan.
 *
 * The `benefits` blob must be in the canonical v5 shape for the plan's
 * coverage type (dental, vision, accident, cancer, criticalIllness, or
 * hospitalIndemnity). The coverage type is resolved server-side from the
 * plan record — callers do not need to supply it.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsUpdateProposalPlanBenefitsMutation = (options?: Partial<Options<ProposalsUpdateProposalPlanBenefitsData>>): UseMutationOptions<ProposalsUpdateProposalPlanBenefitsResponse, AxiosError<DefaultError>, Options<ProposalsUpdateProposalPlanBenefitsData>> => {
    const mutationOptions: UseMutationOptions<ProposalsUpdateProposalPlanBenefitsResponse, AxiosError<DefaultError>, Options<ProposalsUpdateProposalPlanBenefitsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsUpdateProposalPlanBenefits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a single proposal plan
 *
 * Soft-deletes a single carrier proposal plan (CD-89 AC1).
 *
 * Deleting is permitted only when the plan's group is the active version
 * of the RFP-requested plan it answers; a pending requote or an actioned
 * historical quote is read-only in Quote History and the request returns
 * 400 (ADR-031, CD-1792 follow-up). Two carve-outs are exempt from that
 * check regardless of the owning proposal's version state: a duplicate an
 * analyst authored (`origin = analyst`, not carrier quote history), and an
 * unmapped group (no `rfpBenefitPlanGroupId`), which answers no requested
 * plan and so has no version of its own to protect.
 *
 * The version check applies only while the `ppx-quote-history` feature
 * flag evaluates on. When an initialized flag client evaluates it off or
 * undefined (GrowthBook omits a feature whose environment toggle is off),
 * every version a carrier returned is an ordinary board column and any of
 * them may be deleted (CD-1730, CD-3010). A missing flag client keeps the
 * check in place.
 *
 * Deleting a plan also marks its group `padSuppressed`, so the slot is not
 * padded back as an empty "Not received" column when the group now quotes
 * fewer plans than its RFP baseline (CD-3010). Restoring the plan leaves
 * `padSuppressed` set.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsDeleteProposalPlanMutation = (options?: Partial<Options<ProposalsDeleteProposalPlanData>>): UseMutationOptions<ProposalsDeleteProposalPlanResponse, AxiosError<DefaultError>, Options<ProposalsDeleteProposalPlanData>> => {
    const mutationOptions: UseMutationOptions<ProposalsDeleteProposalPlanResponse, AxiosError<DefaultError>, Options<ProposalsDeleteProposalPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsDeleteProposalPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update proposal plan fields
 *
 * Updates plan-level attributes (plan name, funding type, participation
 * requirements, rate guarantee, rate cap, Critical Illness rider charges)
 * for a single carrier proposal plan. All fields
 * are optional; omitted fields are left unchanged. Benefit values are updated
 * separately via PATCH /proposal-plans/{id}/benefits.
 *
 * When `optionName` changes, the plan's enrolled lives and volumes are re-copied from the
 * RFP's Current plan carrying the new label, by the same rules as ingest. Only the
 * relabelled plan is written, so correcting an inverted Low/High takes one call per plan,
 * in either order. The re-copy replaces enrollment on every schedule it covers, including
 * a manual edit there; schedules it does not cover, plans in a group the copy does not
 * apply to (no Current plan, several Current groups, or no Current plan with that label),
 * and plans whose group's analyst chose the carrier's figures (see
 * `PATCH /proposal-plan-groups/{id}`), keep their figures.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsUpdateProposalPlanFieldsMutation = (options?: Partial<Options<ProposalsUpdateProposalPlanFieldsData>>): UseMutationOptions<ProposalsUpdateProposalPlanFieldsResponse, AxiosError<DefaultError>, Options<ProposalsUpdateProposalPlanFieldsData>> => {
    const mutationOptions: UseMutationOptions<ProposalsUpdateProposalPlanFieldsResponse, AxiosError<DefaultError>, Options<ProposalsUpdateProposalPlanFieldsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsUpdateProposalPlanFields({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore a deleted proposal plan
 *
 * Undoes a soft-delete of a single carrier proposal plan — the "Undo"
 * action offered after Delete Plan.
 *
 * Subject to the same version-state guard as delete: the request returns
 * 400 when the plan's group is a non-active, mapped proposal version. An
 * unmapped group, or a duplicate an analyst authored, is exempt from that
 * check regardless of the owning proposal's version state, and the check
 * applies only while `ppx-quote-history` evaluates on (same carve-outs and
 * flag behavior as DELETE /proposal-plans/{id}). Restoring does not clear
 * the group's `padSuppressed` set by the delete.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsRestoreProposalPlanMutation = (options?: Partial<Options<ProposalsRestoreProposalPlanData>>): UseMutationOptions<ProposalsRestoreProposalPlanResponse, AxiosError<DefaultError>, Options<ProposalsRestoreProposalPlanData>> => {
    const mutationOptions: UseMutationOptions<ProposalsRestoreProposalPlanResponse, AxiosError<DefaultError>, Options<ProposalsRestoreProposalPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsRestoreProposalPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a proposal plan group
 *
 * Soft-deletes a proposal plan group from the SBS page (CD-89 AC1).
 *
 * Deleting is permitted only when the group is the active version of the
 * RFP-requested plan it answers; a pending requote or an actioned
 * historical quote is read-only in Quote History and the request returns
 * 400 (ADR-031, CD-1792 follow-up). Two carve-outs are exempt from that
 * check regardless of the owning proposal's version state: a duplicate an
 * analyst authored (`origin = analyst`, not carrier quote history), and an
 * unmapped group (no `rfpBenefitPlanGroupId`), which answers no requested
 * plan and so has no version of its own to protect.
 *
 * The version check applies only while the `ppx-quote-history` feature
 * flag evaluates on. When an initialized flag client evaluates it off or
 * undefined (GrowthBook omits a feature whose environment toggle is off),
 * every version a carrier returned is an ordinary board column and any of
 * them may be deleted (CD-1730, CD-3010). A missing flag client keeps the
 * check in place.
 *
 */
export const proposalsDeleteProposalPlanGroupMutation = (options?: Partial<Options<ProposalsDeleteProposalPlanGroupData>>): UseMutationOptions<ProposalsDeleteProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsDeleteProposalPlanGroupData>> => {
    const mutationOptions: UseMutationOptions<ProposalsDeleteProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsDeleteProposalPlanGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsDeleteProposalPlanGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update proposal plan group fields
 *
 * Updates group-level fields for a single carrier proposal plan group.
 * All fields are optional; omitted fields are left unchanged. Sending an
 * empty `footnote` clears it.
 *
 * `enrollmentDecision` records the analyst's choice between the Current plan's enrollment
 * and the enrollment the carrier quoted. The Quotes grid offers one choice for all of a
 * group's options, so it is recorded on every plan of the group, with the analyst who
 * chose and the time. `kept_current` records the choice and leaves the quote's enrollment
 * as it is. `used_carrier` also puts the carrier's lives and volume back on the quote's
 * rates, where the carrier quoted one; the stored carrier figures stay. Neither changes
 * the Current plan. A plan the carrier quoted no enrollment for is not decided, since it
 * has no carrier figures to compare or restore.
 *
 * A choice can be changed. Choosing `kept_current` after `used_carrier` puts the Current
 * plan's lives and volume back on the quote, paired by each plan's label as it then stands.
 * Relabelling a plan through `PATCH /proposal-plans/{id}` leaves the carrier's figures in
 * place once `used_carrier` was chosen.
 *
 * A decision is accepted for any group the carrier quoted enrollment for, whether or not
 * it differs from Current. `enrollmentNeedsDecision` only says whether a flagged group
 * still awaits one. For a group the carrier quoted no enrollment for, the request returns
 * 400 and nothing is stored. A value other than `kept_current` or `used_carrier` also
 * returns 400.
 *
 * The request is saved as a whole or not at all: if the decision cannot be recorded, the
 * other fields sent with it, such as `footnote`, are not saved either.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsUpdateProposalPlanGroupFieldsMutation = (options?: Partial<Options<ProposalsUpdateProposalPlanGroupFieldsData>>): UseMutationOptions<ProposalsUpdateProposalPlanGroupFieldsResponse, AxiosError<DefaultError>, Options<ProposalsUpdateProposalPlanGroupFieldsData>> => {
    const mutationOptions: UseMutationOptions<ProposalsUpdateProposalPlanGroupFieldsResponse, AxiosError<DefaultError>, Options<ProposalsUpdateProposalPlanGroupFieldsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsUpdateProposalPlanGroupFields({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace the active quote with a pending requote
 *
 * Promotes a pending requote to the active version of the RFP-requested plan
 * it answers and demotes the prior active quote for that requested plan (which
 * moves to Quote History). Scoped per (rfp, carrier, requested plan) — the same
 * grain as `carrierQuoteVersion` — so replacing one requested plan's quote never
 * affects another requested plan sharing the same proposal (ADR-031, CD-1792
 * follow-up). The target must be a pending requote (`requoteReviewState =
 * pending`); otherwise 400. Sets `requoteReviewState = actioned` on the
 * promoted group.
 *
 */
export const proposalsReplaceProposalPlanGroupMutation = (options?: Partial<Options<ProposalsReplaceProposalPlanGroupData>>): UseMutationOptions<ProposalsReplaceProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsReplaceProposalPlanGroupData>> => {
    const mutationOptions: UseMutationOptions<ProposalsReplaceProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsReplaceProposalPlanGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsReplaceProposalPlanGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disregard a pending requote
 *
 * Resolves a pending requote without promoting it: `requoteReviewState`
 * becomes `actioned` and `isActiveVersion` stays false, so the requote drops
 * off the SBS board into Quote History and the requested plan's prior active
 * quote is left in place. Scoped per (rfp, carrier, requested plan) (ADR-031,
 * CD-1792 follow-up). The target must be a pending requote; otherwise 400.
 *
 */
export const proposalsDisregardProposalPlanGroupMutation = (options?: Partial<Options<ProposalsDisregardProposalPlanGroupData>>): UseMutationOptions<ProposalsDisregardProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsDisregardProposalPlanGroupData>> => {
    const mutationOptions: UseMutationOptions<ProposalsDisregardProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsDisregardProposalPlanGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsDisregardProposalPlanGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Promote a historical quote to active
 *
 * Re-promotes a superseded (historical) quote to the active version of the
 * RFP-requested plan it answers, demoting whatever is currently active for
 * that requested plan (which moves to Quote History). Scoped per (rfp,
 * carrier, requested plan) (ADR-031, CD-1792 follow-up). The target must be an
 * actioned, inactive quote (`isActiveVersion = false`, `requoteReviewState =
 * actioned`); otherwise 400. Restoring an older version over a newer one is
 * permitted — `isActiveVersion` is the analyst-chosen "current shown version".
 *
 */
export const proposalsPromoteProposalPlanGroupMutation = (options?: Partial<Options<ProposalsPromoteProposalPlanGroupData>>): UseMutationOptions<ProposalsPromoteProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsPromoteProposalPlanGroupData>> => {
    const mutationOptions: UseMutationOptions<ProposalsPromoteProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsPromoteProposalPlanGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsPromoteProposalPlanGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore a deleted quote
 *
 * Clears the deletion on a quote the analyst deleted, bringing it back out of
 * Quote History (CD-89 AC1). The group and the plans deleted with it are
 * restored together.
 *
 * Never promotes. Deleting is permitted only on the active version, so a quote
 * deleted while active returns to the board; one that a Replace superseded while
 * it sat deleted returns to Quote History instead. The response body carries the
 * resolved state so the caller can say which happened.
 *
 * Idempotent: restoring a quote that is not deleted is a no-op, not an error.
 *
 */
export const proposalsRestoreProposalPlanGroupMutation = (options?: Partial<Options<ProposalsRestoreProposalPlanGroupData>>): UseMutationOptions<ProposalsRestoreProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsRestoreProposalPlanGroupData>> => {
    const mutationOptions: UseMutationOptions<ProposalsRestoreProposalPlanGroupResponse, AxiosError<DefaultError>, Options<ProposalsRestoreProposalPlanGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsRestoreProposalPlanGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a plan to an existing proposal plan group
 *
 * Creates a real plan inside an existing quoted proposal plan group at the
 * given 1-based position — an analyst filling an under-quoted group's
 * empty pad slot (partial fill). The group's `size` grows to cover the new
 * plan when needed. `benefits` is optional: omitting it creates a bare
 * plan of the coverage's type for the analyst to fill in afterwards.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsAddProposalPlanToGroupMutation = (options?: Partial<Options<ProposalsAddProposalPlanToGroupData>>): UseMutationOptions<ProposalsAddProposalPlanToGroupResponse, AxiosError<DefaultError>, Options<ProposalsAddProposalPlanToGroupData>> => {
    const mutationOptions: UseMutationOptions<ProposalsAddProposalPlanToGroupResponse, AxiosError<DefaultError>, Options<ProposalsAddProposalPlanToGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsAddProposalPlanToGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a proposal commission
 *
 * Deletes the carrier's returned commission for a single proposal
 * plan.
 *
 * Requires write access to the RFP.
 *
 */
export const proposalsDeleteProposalCommissionMutation = (options?: Partial<Options<ProposalsDeleteProposalCommissionData>>): UseMutationOptions<ProposalsDeleteProposalCommissionResponse, AxiosError<DefaultError>, Options<ProposalsDeleteProposalCommissionData>> => {
    const mutationOptions: UseMutationOptions<ProposalsDeleteProposalCommissionResponse, AxiosError<DefaultError>, Options<ProposalsDeleteProposalCommissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsDeleteProposalCommission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert a proposal commission
 *
 * Creates or updates the carrier's returned commission for a single
 * proposal plan. Scoped to a proposal plan (not a coverage), so
 * proposals with multiple plans per coverage have independent
 * commission rows.
 *
 * When `returnedType` is `notDisclosed`, `returnedAmount` and
 * `returnedHeapedAmount` must both be omitted. When `returnedType` is
 * `heaped`, `returnedAmount` must be omitted (`returnedHeapedAmount`
 * carries the value instead). For all other types,
 * `returnedHeapedAmount` must be omitted.
 *
 * Requires write access to the RFP.
 *
 */
export const proposalsUpdateProposalCommissionMutation = (options?: Partial<Options<ProposalsUpdateProposalCommissionData>>): UseMutationOptions<ProposalsUpdateProposalCommissionResponse, AxiosError<DefaultError>, Options<ProposalsUpdateProposalCommissionData>> => {
    const mutationOptions: UseMutationOptions<ProposalsUpdateProposalCommissionResponse, AxiosError<DefaultError>, Options<ProposalsUpdateProposalCommissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposalsUpdateProposalCommission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rfpsGetRfpQueryKey = (options: Options<RfpsGetRfpData>) => createQueryKey('rfpsGetRfp', options, false, ['rfps_btx', 'rfps']);

/**
 * Get an RFP
 *
 * Returns the full RFP structure including all coverages, benefit
 * plan groups, benefit plans, and broker commissions.
 *
 * If the RFP does not yet exist in BTX, it is initialized from the
 * broker portal configuration. New Business plans are pre-filled
 * from a matching Centro Benchmark plan design when one exists;
 * other plans start empty.
 *
 * If the RFP already exists, each call first reconciles its
 * coverages with the broker portal, and the response reflects the
 * reconciled state. When a coverage has moved from New Business to
 * Current, each of its benchmark-filled plans is resolved one of
 * two ways:
 *
 * - If the plan has been changed since it was filled (edited plan
 * fields, rates, or eligibility classes), it is kept as is, with
 * the same ID, and marked Current.
 * - Otherwise it is replaced by an empty Current plan with a new
 * ID. The replaced plan is soft-deleted with its benefit data
 * kept, and no longer appears in the response.
 *
 * This is the primary read endpoint for AI integrations that need
 * to discover the plan structure (UUIDs, identifiers, coverage
 * types) before issuing batch updates.
 *
 */
export const rfpsGetRfpOptions = (options: Options<RfpsGetRfpData>) => queryOptions<RfpsGetRfpResponse, AxiosError<DefaultError>, RfpsGetRfpResponse, ReturnType<typeof rfpsGetRfpQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rfpsGetRfp({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rfpsGetRfpQueryKey(options)
});

export const rfpsExportRfpPayloadQueryKey = (options: Options<RfpsExportRfpPayloadData>) => createQueryKey('rfpsExportRfpPayload', options, false, ['rfps_btx', 'rfps']);

/**
 * Export an RFP's v5 payload
 *
 * Returns the v5 payload a submission of the RFP would send carriers,
 * built exactly as `POST /rfps/{id}/submit` builds it, with every
 * coverage, but neither checked for submission (the census-to-class
 * check included) nor sent. Nothing is recorded: no RFP version,
 * submission, or proposal. The payload is always in the current spec
 * version; an `X-RFP-Spec-Version` request header is ignored, and the
 * response header names the version.
 *
 * The golden-set tool uses it to score what RUMI built on a replay RFP
 * against an analyst's submission, which carrier-rfpq stores in the
 * same shape.
 *
 */
export const rfpsExportRfpPayloadOptions = (options: Options<RfpsExportRfpPayloadData>) => queryOptions<RfpsExportRfpPayloadResponse, AxiosError<DefaultError>, RfpsExportRfpPayloadResponse, ReturnType<typeof rfpsExportRfpPayloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rfpsExportRfpPayload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rfpsExportRfpPayloadQueryKey(options)
});

/**
 * Set coverage completion status
 *
 * Marks a coverage (line of coverage) as complete or incomplete
 * for a given RFP.
 *
 * **Marking complete** triggers server-side validation:
 * - The coverage must have at least one benefit plan group.
 * - At least one eligibility class must be assigned.
 * - All required benefit plan fields must be populated.
 * - All benefit plan group validations must pass.
 *
 * If validation fails, a `400` response is returned with an
 * array of validation errors. The coverage is **not** marked
 * complete.
 *
 * **Marking incomplete** skips validation and always succeeds.
 *
 * For coverages with multiple product types (e.g., Dental PPO
 * and Dental HMO), the `productType` query parameter is
 * required to target a specific product type.
 *
 */
export const rfpsSetCoverageCompletionMutation = (options?: Partial<Options<RfpsSetCoverageCompletionData>>): UseMutationOptions<RfpsSetCoverageCompletionResponse, AxiosError<RfpsSetCoverageCompletionError>, Options<RfpsSetCoverageCompletionData>> => {
    const mutationOptions: UseMutationOptions<RfpsSetCoverageCompletionResponse, AxiosError<RfpsSetCoverageCompletionError>, Options<RfpsSetCoverageCompletionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rfpsSetCoverageCompletion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rfpsListCarrierNoteExistenceQueryKey = (options: Options<RfpsListCarrierNoteExistenceData>) => createQueryKey('rfpsListCarrierNoteExistence', options, false, [
    'rfps_btx',
    'rfps',
    'notes'
]);

/**
 * List carriers with saved notes
 *
 * Returns the IDs of carriers that have saved (non-deleted) notes
 * for an RFP, without loading note content. Useful for seeding UI
 * state to know which carriers have notes before individual loads.
 *
 */
export const rfpsListCarrierNoteExistenceOptions = (options: Options<RfpsListCarrierNoteExistenceData>) => queryOptions<RfpsListCarrierNoteExistenceResponse, AxiosError<DefaultError>, RfpsListCarrierNoteExistenceResponse, ReturnType<typeof rfpsListCarrierNoteExistenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rfpsListCarrierNoteExistence({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rfpsListCarrierNoteExistenceQueryKey(options)
});

/**
 * Upsert field comments across benefit plans
 *
 * Writes field-level comment state on any number of fields, across
 * any number of benefit plans of one RFP, in one transaction.
 *
 * Each field is matched on its benefit plan and `fieldPath`:
 * - A field with no comment gets one. Omitted values take their
 * defaults, and `needsReview` defaults to `true`, so send it
 * explicitly when the field should stay out of review. A field
 * that only sets `manuallyEdited: true`, with no comment text,
 * defaults to `false` instead: the edited mark alone doesn't put
 * a field in review.
 * - A field with a comment is updated. Omitted values are left
 * unchanged; an empty string clears `comment` or
 * `aiOriginalValue`.
 * - A field whose comment was deleted has it restored as if it
 * were new: values the request omits take their defaults rather
 * than the deleted comment's.
 *
 * Every benefit plan must belong to the RFP in the path. If any
 * does not, or if any field fails validation, nothing is written.
 *
 */
export const rfpsUpsertFieldCommentsMutation = (options?: Partial<Options<RfpsUpsertFieldCommentsData>>): UseMutationOptions<RfpsUpsertFieldCommentsResponse2, AxiosError<DefaultError>, Options<RfpsUpsertFieldCommentsData>> => {
    const mutationOptions: UseMutationOptions<RfpsUpsertFieldCommentsResponse2, AxiosError<DefaultError>, Options<RfpsUpsertFieldCommentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rfpsUpsertFieldComments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
